const CAL_CONF_MODAL_LAST_SHOWN_COOKIE = 'CalConfModalLastShown_';
const HOURS_24_IN_MS = 86400000;

export const canShowConfirmAvailModal = (shouldBypassTimer, ssoId) => {
  if (shouldBypassTimer) return true;

  const cookie = CAL_CONF_MODAL_LAST_SHOWN_COOKIE + ssoId;
  const lastShown = Number(PSSessions.Cookies.get(cookie));
  return !lastShown || (HOURS_24_IN_MS <= Date.now() - lastShown);
};

export const updateConfirmAvailModalShown = (ssoId) => {
  const cookie = CAL_CONF_MODAL_LAST_SHOWN_COOKIE + ssoId;
  PSSessions.Cookies.set(cookie, Date.now(), Date.now() + HOURS_24_IN_MS * 7);
};
